import { render, staticRenderFns } from "./CircleComponent.vue?vue&type=template&id=097efb20"
import script from "./CircleComponent.vue?vue&type=script&lang=ts"
export * from "./CircleComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports